/**
 * 書籍バーコード (EAN-13) から ISBN を取り出すユーティリティ。
 */

/**
 * 読み取った EAN-13 の文字列が ISBN なら 13 桁の数字を返す。
 *
 * 日本の書籍は上下 2 段のバーコードが並んでおり、下段は分類・価格コード
 * (192 始まりの「日本図書コード」) なので ISBN として使えない。
 * ISBN のプレフィックスである 978 / 979 で始まるものだけを採用する。
 */
export const extractIsbnFromBarcode = (text: string): string | null => {
  const digits = text.replace(/\D/g, '')
  if (digits.length !== 13) return null
  if (!digits.startsWith('978') && !digits.startsWith('979')) return null
  return digits
}
